import { Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { BrowsedJobDetailsContainerStyled } from '../TechnicianBrowsedJobDetails/style';

type Props = {
  buildingId: string;
  buildingName: string;
  addressOfProperty: string;
};

const PropertyInformation = ({ addressOfProperty, buildingName }: Props) => {
  return (
    <BrowsedJobDetailsContainerStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        PROPERTY INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled className="jobInformation">
          <Typography className="title">Building Name :</Typography>
          <Typography className="value">{buildingName}</Typography>
        </InfoRowStyled>
        <InfoRowStyled className="jobInformation">
          <Typography className="title">Address of Property :</Typography>
          <Typography className="value">{addressOfProperty}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </BrowsedJobDetailsContainerStyled>
  );
};

export default PropertyInformation;
